<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div mat-dialog-title>
  Edit User
  <button mat-icon-button (click)="handleEditComplete(false)" title="Cancel" class="close-button" tabindex="-1">
    <mat-icon class="mdi-24px center-self" fontIcon="mdi-close-circle-outline"></mat-icon>
  </button>
</div>
@if (!!data && !!data.user) {
<div mat-dialog-content>
  <div class="add-margin">
    <div>
      <mat-form-field class="full-width">
        <mat-label>Name</mat-label>
        <input type="text" matInput [formControl]="userNameFormControl" placeholder="Name (required)"
          (blur)="saveUser('name')" value="{{data.user.name}}">
        @if (userNameFormControl.hasError('required')) {
        <mat-error>
          Name is <strong>required</strong>
        </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="add-margin">
    <div>
      <mat-form-field class="full-width">
        <mat-label>ID</mat-label>
        <input matInput placeholder="ID (required)" [formControl]="idFormControl" (blur)="saveUser('id')"
          value="{{data.user.id}}">
        @if (idFormControl.hasError('required')) {
        <mat-error>
          ID is <strong>required</strong>
        </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="add-margin">
    <div>
      <mat-form-field class="full-width">
        <mat-label>Email</mat-label>
        <input matInput placeholder="Email" [formControl]="emailFormControl" (blur)="saveUser('email')"
          value="{{data.user.email}}">
      </mat-form-field>
    </div>
  </div>
  <div class="cssLayoutRowStartCenter bottom-button">
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(true)" [disabled]="!errorFree()"
        style="margin-left: 40px;">Save</button>
    </div>
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
    </div>
  </div>
</div>
}
